import "antd/es/image/style";
import _Image from "antd/es/image";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classnames from 'classnames';
import defaultIcon from '../normal/default.svg';
import './style/index.less';

var PlatformCard = function PlatformCard(_ref) {
  var platform = _ref.platform,
      className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick,
      badgeText = _ref.badgeText;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDefault = _useState2[0],
      setShowDefault = _useState2[1];

  var key = typeof platform === 'string' ? platform : platform.key;
  var name = typeof platform === 'string' ? platform : platform.name;
  return _jsxs("div", {
    className: classnames('igloo-platform', className, badgeText && 'igloo-platform-has-badge-text'),
    onClick: onClick,
    style: style,
    "data-badge-text": badgeText,
    children: [showDefault && _jsxs("div", {
      style: {
        textAlign: 'center'
      },
      children: [_jsx("img", {
        src: defaultIcon,
        className: "igloo-platform-defaultLogo"
      }), _jsx("div", {
        className: "igloo-platform-name",
        children: name
      })]
    }), !showDefault && _jsx(_Image, {
      width: 200,
      height: 200,
      src: "https://static.iglooinsure.com/partner/normal/".concat(key.toLowerCase(), ".svg"),
      onError: function onError() {
        return setShowDefault(true);
      },
      preview: false
    })]
  });
};

export default PlatformCard;